(function () {
  angular.module('lif.controllers').controller('memberListBlockController', memberListBlockController);
  memberListBlockController.$inject = ['$rootScope', '$scope', '$timeout', 'bootstrappedMemberListBlockModel', 'formService', 'userService', 'constants'];

  function memberListBlockController($rootScope, $scope, $timeout, bootstrappedMemberListBlockModel, formService, userService, constants) {
    var vm = this;
    vm.searchResults = [];
    var timeout;
    vm.searching = false;
    vm.adding = false;
    vm.members = bootstrappedMemberListBlockModel.members;
    vm.editable = bootstrappedMemberListBlockModel.editable;

    vm.onSearch = function () {
      if (vm.searchString.length > 0) {
        vm.searching = true;

        if (timeout) {
          $timeout.cancel(timeout);
        }

        timeout = $timeout(function () {
          var searchString = vm.searchString;
          formService.searchForMember(bootstrappedMemberListBlockModel.groupPage, searchString).then(function (searchResults) {
            if (vm.searchString.length > 0) {
              vm.searchResults = searchResults;
              vm.searching = false;
            }
          }, function () {
            vm.searching = false;
          });
        }, 500);
      } else {
        vm.searchResults = [];
        vm.searching = false;
      }
    };

    vm.addUserToGroup = function (userName) {
      vm.adding = true;
      formService.addUserToGroup(bootstrappedMemberListBlockModel.groupPage, bootstrappedMemberListBlockModel.groupName, userName).then(function (member) {
        vm.members.unshift({
          FirstName: member.FirstName,
          LastName: member.LastName,
          Company: member.Company,
          UserName: member.UserName,
          Email: member.Email
        });
        vm.adding = false;
        vm.searchString = "";
        vm.searchResults = [];
        var groupEvent = {
          Date: member.Date,
          Message: "Lade till " + member.FirstName + " " + member.LastName + " i " + bootstrappedMemberListBlockModel.groupName,
          User: userService.getLoggedInUser().name,
          Id: member.EventId,
          GroupEventType: constants.GroupEventType.Member
        };
        $rootScope.$broadcast('groupEvent', groupEvent);
      }, function () {
        vm.adding = false;
      });
    };

    vm.removeUserFromGroup = function () {
      var member = vm.memberToRemove;
      var index;
      vm.members.forEach(function (item, i) {
        if (item === member) {
          index = i;
        }
      });
      member.removing = true;
      formService.removeUserFromGroup(member.UserName, bootstrappedMemberListBlockModel.groupName, bootstrappedMemberListBlockModel.groupPage).then(function (eventId) {
        vm.members.splice(index, 1);
        var groupEvent = {
          Date: member.Date,
          Message: "Tog bort " + member.FirstName + " " + member.LastName + " från " + bootstrappedMemberListBlockModel.groupName,
          User: userService.getLoggedInUser().name,
          Id: eventId,
          GroupEventType: constants.GroupEventType.Member
        };
        $rootScope.$broadcast('groupEvent', groupEvent);
        member.removing = false;
        $("#removeMemberModal").modal("hide");
      }, function () {
        member.removing = false;
        $("#removeMemberModal").modal("hide");
      });
    };

    vm.showRemoveMemberModal = function (member) {
      vm.memberToRemove = member;
      $("#removeMemberModal").modal("show");
    };
  }
})();